import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import $ from 'jquery';
$(function () {
    function convertRemToPixels(rem) {
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }

    if ($('#hero-home .swiper-wrapper .swiper-slide').length > 1) {
        initHeroSlider(true);
    } else {
        initHeroSlider(false);
    }

    function initHeroSlider(loopParam) {
        const heroHome = new Swiper('#hero-home', {
            modules: [Pagination],
            // Optional parameters
            loop: loopParam,
            autoplay: {
                delay: 2000,
                disableOnInteraction: false,
            },
            slidesPerView: 1,
            slidesPerGroup: 1,
            // If we need pagination
            pagination: {
                el: '#hero-home .swiper-pagination',
                clickable: true,
            },
        });
    }
    const servicesSlider = new Swiper('#our-services .slider', {
        modules: [Pagination],
        // Optional parameters
        loop: true,
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: convertRemToPixels(40),
        pagination: {
            el: '#our-services .swiper-pagination',
            clickable: true,
        },

    });
    if ($(window).width() <= 760) {
        // destroy slider
        if ($('#our-services .slider').length) {
            servicesSlider.destroy(true, true);
        }
    }

})